/**
 * Public, non-secret build configuration.
 * The browser only needs to know where the gateway lives; company id, credentials and upstream
 * URLs are configured on the gateway server (see apps/gateway/.env.example).
 */
export const env = {
  /** Base path of the versioned gateway API. Same-origin by default (dev server proxies /api). */
  apiBase: (import.meta.env.VITE_API_BASE as string | undefined)?.replace(/\/+$/, '') || '/api/v1',
  appName: (import.meta.env.VITE_APP_NAME as string | undefined) || 'Aliens OS',
  version: (import.meta.env.VITE_APP_VERSION as string | undefined) || '0.1.0',
  isProd: import.meta.env.PROD,
} as const
